export default {
  type: 'qtrMetricsModes',
  name: 'Quarterly Completeness Modes',
  permissions: {
    view: { app: 'metrics_dash', role: 'metrics_qtr_data' },
    insert: { app: 'metrics_dash', role: 'metrics_qtr_data' },
    update: { app: 'metrics_dash', role: 'metrics_qtr_data' },
    delete: { app: 'metrics_dash', role: 'metrics_qtr_data' }
  },
  search: {
    search: 'allQtrMetricsModes',
    orderBy: {
      type: 'QtrMetricsModesOrderBy',
      default: 'DATASTREAM_ASC'
    },
    fields: [
      {
        name: 'datastream',
        order: 'DATASTREAM'
      },
      {
        name: 'startDate',
        order: 'START_DATE',
        searchable: false
      },
      {
        name: 'endDate',
        order: 'END_DATE',
        searchable: false
      },
      {
        name: 'mode',
        order: 'MODE',
        searchable: false
      }
    ]
  },
  save: {
    fields: [
      {
        field: 'datastream',
        required: true
      },
      {
        field: 'startDate',
        type: 'Date',
        required: true
      },
      {
        field: 'endDate',
        type: 'Date'
      },
      {
        field: 'mode',
        type: 'Int',
        requrired: true
      }
    ],
    key: ['datastream', 'startDate'],
    input: 'qtrMetricsMode',
    create: 'createQtrMetricsMode',
    delete: 'deleteQtrMetricsMode',
    update: 'updateQtrMetricsMode'
  },
  load: {
    nodeId: 'qtrMetricsMode',
    key: 'qtrMetricsModeByDatastreamAndStartDate'
  },
  form: {
    print: false,
    schema: [
      {
        name: 'datastream',
        required: true
      },
      {
        name: 'startDate',
        type: 'date',
        required: true
      },
      {
        name: 'endDate',
        type: 'date'
      },
      {
        name: 'mode',
        type: 'number'
      }
    ]
  }
}
